import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        channel: null,
    }),

    getters: {
        getUser: (state) => state.user,
        getUserChannel: (state) => state.channel,
    },

    actions: {
        setUser(payload) {
            this.user = payload.user;
            this.channel = 'private-user-' + payload.user.id;
        },

        clearUser() {
            this.user = null;
            this.channel = null;
        }
    }
});



